'use client';

import type { PropsWithChildren, ReactNode } from 'react';
import NoSSR from '../NoSSR';
import { FullStoryInit } from './FullStoryInit';

export function FullStoryWrapper({ children }: PropsWithChildren): ReactNode {
	return (
		<>
			<NoSSR>
				<FullStoryInit />
			</NoSSR>
			{children}
		</>
	);
}
